
<template>
    <v-container class="" style="padding: 6px;">
        <!-- >>> Resource was chosen: -------------------------------------- -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource !== undefined">
            <!-- >>> Left Side: -------------------------------------------- -->
            <v-col cols="6" md="3">
                <v-card class="pa-2" style="background-color: #fff;" outlined>
                    <table id="customers">
                        <thead>
                            <tr>
                                <th style="background-color: #CB67A0;">
                                    <v-card-title style="text-align: left; font-weight: 600; font-size: 14px; color: #fff;">
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.genLastname }}, {{ get_flights_ResourceDetails_ResourceAskedFor.genFirstName }}</p>
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.contractFunction }} in {{ get_flights_ResourceDetails_ResourceAskedFor.contractBaseStationCode }}, {{ get_flights_ResourceDetails_ResourceAskedFor.comPhone1 }}</p>
                                    </v-card-title>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </v-card>

                <v-card class="pa-2"  style="margin-top: 10px; background-color: #fff;" outlined>
                    <v-card-text>
                        <datetime v-model="startDate" label="Brief Date:" disabled="false" disabledTime="true" ref="startTimer" briefcaller="step5" />
                    </v-card-text>
                </v-card>

                <v-card class="pa-2"  min-height="276" style="margin-top: 10px; background-color: #fff;" outlined>
                     <v-card-text style="text-align: left; font-weight: 500; font-size: 16px;">
                        <!-- >>> 'Flights this Day': ------------------------ -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length > 0">Flights this Day:</span>
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length === 0">No Flights this Day:</span>
                        <template v-for="(flight, index) in flightsThisDay">
                            <p style="font-size: 13px; font-weight: 500;" :key="index"><strong>{{ flight.flight }}:</strong> {{ flight.hours }} (LT), {{ flight.leg }}: {{ flight.ft }}h</p>
                        </template>

                        <!-- >>> 'CiCo': ----------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="myFormattedDate_CheckIn"><strong>Check in: </strong>{{ myFormattedDate_CheckIn }}</p>
                        <p style="font-size: 13px; font-weight: 500;" v-if="myFormattedDate_CheckOut"><strong>Check out: </strong>{{ myFormattedDate_CheckOut }}</p>

                        <!-- >>> 'Sectors': -------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="sectorsThisDay !== null"><strong>Sectors: </strong>{{ sectorsThisDay }}</p><br />

                        <!-- >>> 'Total FDP': ------------------------------ -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="fdtInfo !== null"><strong>FDP Total: </strong>{{ fdtInfo.formatted_fdt }}</p>

                        <!-- >>> 'Total FT/DT': ------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;">
                            <span v-if="totalFTThisDay !== null"><strong>FT Total: </strong>{{ totalFTThisDay }}, </span>
                            <span v-if="totalDTThisDay !== null"><strong>DT Total: </strong>{{ totalDTThisDay }}</span>
                        </p><br />

                        <!-- >>> 'Rest Periods': --------------------------- -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;">Rest Periods:</span>
                        <p style="font-size: 13px; font-weight: 500;">previous RP: {{ previousRestPeriod }}h, <strong>min {{ minimumPreviousRestPeriod }} - ... / ...</strong></p>
                        <p style="font-size: 13px; font-weight: 500;">next RP: {{ nextRestPeriod }}h, <strong>min {{ minimumNextRestPeriod }} - ... / ...</strong></p>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <<< Left Side: -------------------------------------------- -->


            <!-- >>> Right Side: ------------------------------------------- -->
            <v-col cols="12" sm="6" md="9">
                <v-card class="pa-2" min-height="480" style="background-color: #fff;" outlined>
                    <!-- >>> 'Rec Rest1': ---------------------------------- -->
                    <table id="customers">
                        <thead>
                            <tr>
                                <th width="33%">Rec Rest1:</th>
                                <th width="33%">Status:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div v-html="myPreviousDateLine"></div>
                                    <div v-html="myPrevFromToLine"></div>
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <td>
                                   <div>Time between: <strong>{{ timeBetweenRecRest1 }}h</strong> / max {{ maxBetweenRestRec1 }}h </div>
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <td>
                                   <div>Early/late/night between: <strong>{{ ES_LF_ND_count }}</strong></div>
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <td>
                                   <div v-html="myNextDateLine"></div>
                                   <div v-html="myNextFromToLine"></div>
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'recrest1' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'recrest1' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- >>> 'Rec Rest2': ---------------------------------- -->
                    <table id="customers">
                        <thead>
                            <tr>
                                <th width="33%">Rec Rest2:</th>
                                <th width="33%">Status:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div>this month: <strong>{{ resRest2 }}</strong> / min {{ minResRest2 }}</div>
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'recrest2' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'recrest2' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- >>> 'Reduced Rest': ------------------------------- -->
                    <table id="customers">
                        <thead>
                            <tr>
                                <th width="33%">Reduced Rest:</th>
                                <th width="33%">Status:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div><strong>Reduced Rest: </strong>{{ myReducedRestStart }} - {{ this.myReducedRestEnd }}</div>
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span style="font-size: 12px; font-weight: 500;">Note:</span><span style="font-size: 12pxem; font-weight: 400;"> Config Rest Periods</span>
                </v-card>
            </v-col>
            <!-- <<< Right Side: ------------------------------------------- -->
        </v-row>
        <!-- <<< Resource was chosen: -------------------------------------- -->




        <!-- >>> Resource was not chosen yet: ------------------------------ -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource === undefined">
            <v-col cols="12">
                <v-card class="pa-2" style="background-color: #fff;">
                    <v-card-title class="pa-4" style="color: #CB67A0; font-size: 15px; font-weight: 500;">
                        <i style="font-size:20px; color: #A4C2A5;" class="b-fa b-fa-check-circle"></i> Attention: Dear User, first select a resource in the upper area (click checkbox).
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <!-- <<< Resource was not chosen yet: ------------------------------ -->
    </v-container>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';


    export default {
        name: 'Step5Content',

        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                yearlyList: {},
                flightsThisDay: [],
                myFormattedDate_CheckIn: null,
                myFormattedDate_CheckOut: null,
                sectorsThisDay: null,
                totalFTThisDay: null,
                totalDTThisDay: null,
                fdtInfo: null,

                previousRestPeriod: null,
                minimumPreviousRestPeriod: null,
                nextRestPeriod: null,
                minimumNextRestPeriod: null,
                // >>> --------------------------
                previousRecRest1: null,
                nextRecRest1: null,

                previousRec1Duration: null,
                minimumRestRec1: null,
                nextRec1Duration: null,

                myReducedRestStart: null,
                myReducedRestEnd: null,

                myPreviousDateLine: null,
                myPrevFromToLine: null,
                myNextDateLine: null,
                myNextFromToLine: null,

                timeBetweenRecRest1: null,
                maxBetweenRestRec1: null,

                ES_LF_ND_count: null,

                resRest2: null,
                minResRest2: null,
                myNextDateLine_ledValue: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /******************************************************************* Picker
            * watch::get_flights_CrewDetails_SavedPayload
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_CrewDetails_SavedPayload(v) {

                let me = this,
                    timestamp = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step5Content.vue >>> watch get_flights_CrewDetails_SavedPayload');
                if (v.date !== undefined) {
                    timestamp = new Date(v.date).setHours(23, 59, 0, 0);
                    this.startDate = new Date(timestamp);
                }

            }, // eo function get_flights_CrewDetails_SavedPayload()


            /******************************************************************* Brief
            * watch::get_flights_BriefDetails_Flights_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_Flights_ThisDay(v) {

                this.flightsThisDay = v;

            }, // eo function get_flights_BriefDetails_Flights_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_DutyCheckin_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_DutyCheckin_ThisDay(v) {

                let tmp1 = null,
                    a = null,
                    b = null,
                    checkin_loc  = null;


                // >>> UTC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    this.myFormattedDate_CheckIn = dayjs.utc(v, dayjs.ISO_8601).format('HH:mm') + ' (UT)';
                } else {
                    this.myFormattedDate_CheckIn = 'empty';
                }

                // >>> LOC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    tmp1 = v;
                    a = tmp1.split("T");
                    b = a[1].split(":");
                    checkin_loc = b[0] + ':' + b[1] + ' (LT)';
                    this.myFormattedDate_CheckIn = this.myFormattedDate_CheckIn + ', ' + checkin_loc;
                }

            }, // eo function get_flights_BriefDetails_DutyCheckin_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_DutyCheckout_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_DutyCheckout_ThisDay(v) {

                let tmp1 = null,
                    a = null,
                    b = null,
                    checkin_loc  = null;


                // >>> UTC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    this.myFormattedDate_CheckOut = dayjs.utc(v, dayjs.ISO_8601).format('HH:mm') + ' (UT)';
                } else {
                    this.myFormattedDate_CheckOut = 'empty';
                }

                // >>> LOC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    tmp1 = v;
                    a = tmp1.split("T");
                    b = a[1].split(":");
                    checkin_loc = b[0] + ':' + b[1] + ' (LT)';
                    this.myFormattedDate_CheckOut = this.myFormattedDate_CheckOut + ', ' + checkin_loc;
                }

            }, // eo function get_flights_BriefDetails_DutyCheckout_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_Sectors_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_Sectors_ThisDay(v) {

                this.sectorsThisDay = v;

            }, // eo function get_flights_BriefDetails_Sectors_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalFT_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_TotalFT_ThisDay(v) {

                this.totalFTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalFT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalDT_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_TotalDT_ThisDay(v) {

                this.totalDTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalDT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_FlightDutyTime_FdtInfo
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_FlightDutyTime_FdtInfo'.
            * Note:
            *
            */
            get_flights_BriefDetails_FlightDutyTime_FdtInfo(v) {

                this.fdtInfo = v;

            }, // eo function get_flights_BriefDetails_FlightDutyTime_FdtInfo()


            /*******************************************************************
            * watch::get_flights_BriefDetails_PreviousRestPeriod_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_PreviousRestPeriod_ThisDay(v) {

                this.previousRestPeriod = v;

            }, // eo function get_flights_BriefDetails_PreviousRestPeriod_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay(v) {

                this.minimumPreviousRestPeriod = v;

            }, // eo function get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_NextRestPeriod_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_NextRestPeriod_ThisDay(v) {

                this.nextRestPeriod = v;

            }, // eo function get_flights_BriefDetails_NextRestPeriod_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay(v) {

                this.minimumNextRestPeriod = v;

            }, // eo function get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay()




            /******************************************************************* 'Right Side'
            * watch::get_flights_ResourceDetails_PreviousRec1Duration
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_PreviousRec1Duration(v) {

                this.previousRec1Duration = v;

            }, // eo function get_flights_ResourceDetails_PreviousRec1Duration()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_MinimumRestRec1
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_MinimumRestRec1(v) {

                this.minimumRestRec1 = v;

            }, // eo function get_flights_ResourceDetails_MinimumRestRec1()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_NextRec1Duration
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_NextRec1Duration(v) {

                this.nextRec1Duration = v;

            }, // eo function get_flights_ResourceDetails_NextRec1Duration()



            /*******************************************************************
            * watch::get_flights_ResourceDetails_PreviousRecRest1
            *
            * Desc: Monitor/Watch.
            * Note:
            *
            */
            get_flights_ResourceDetails_PreviousRecRest1(v) {

                let myPreviousRecRest1_fromDate	= '',
                    myPreviousRecRest1_toDate = '';


                // >>> ----------------------------
                this.previousRecRest1 = v;


                // >>> ----------------------------
                if (!Vue.prototype.$isEmpty(this.previousRecRest1 && this.previousRecRest1.fromDate)) {
                    myPreviousRecRest1_fromDate	= dayjs.utc(this.previousRecRest1.fromDate, dayjs.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' (UT)';
                } else {
                    myPreviousRecRest1_fromDate = '';
                }

                if (!Vue.prototype.$isEmpty(this.previousRecRest1 && this.previousRecRest1.toDate)) {
                    myPreviousRecRest1_toDate 	= dayjs.utc(this.previousRecRest1.toDate, dayjs.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' (UT)';
                    this.myReducedRestStart 	= myPreviousRecRest1_toDate; // for reduced Rest (Start - End)
                } else {
                    myPreviousRecRest1_toDate 	= '';
                    this.myReducedRestStart 	= '';
                }


                if (!Vue.prototype.$isEmpty(myPreviousRecRest1_fromDate) || !Vue.prototype.$isEmpty(myPreviousRecRest1_toDate)) {
                    this.myPreviousDateLine 	= 'previous RR1: from ' + myPreviousRecRest1_fromDate + ' - to ' + myPreviousRecRest1_toDate;
                }
                if (Vue.prototype.$isEmpty(myPreviousRecRest1_fromDate) && Vue.prototype.$isEmpty(myPreviousRecRest1_toDate)) {
                    this.myPreviousDateLine 	= 'previous RR1: empty';
                }


                // --------------------------------
                if (!Vue.prototype.$isEmpty(this.previousRec1Duration)) {
                    this.myPrevFromToLine = '<b>' + this.previousRec1Duration + 'h</b> / min ' + this.minimumRestRec1;
                } else {
                    this.myPrevFromToLine = '';
                }

            }, // eo function get_flights_ResourceDetails_PreviousRecRest1()

            /*******************************************************************
            * watch::get_flights_ResourceDetails_NextRecRest1
            *
            * Desc: Monitor/Watch.
            * Note:
            *
            */
            get_flights_ResourceDetails_NextRecRest1(v) {

                let myNextRecRest1_fromDate = '',
                    myNextRecRest1_toDate = '';


                // >>> ----------------------------
                this.nextRecRest1 = v;


                // >>> ----------------------------
                if (!Vue.prototype.$isEmpty(this.nextRecRest1 && this.nextRecRest1.fromDate)) {
                    myNextRecRest1_fromDate = dayjs.utc(this.nextRecRest1.fromDate, dayjs.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' (UT)';
                    this.myReducedRestEnd = myNextRecRest1_fromDate; // for reduced Rest (Start - End)
                } else {
                    myNextRecRest1_fromDate = '';
                    this.myReducedRestEnd = '';
                }

                if (!Vue.prototype.$isEmpty(this.nextRecRest1 && this.nextRecRest1.toDate)) {
                    myNextRecRest1_toDate = dayjs.utc(this.nextRecRest1.toDate, dayjs.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' (UT)';
                } else {
                    myNextRecRest1_toDate = '';
                }

                if (!Vue.prototype.$isEmpty(myNextRecRest1_fromDate) || !Vue.prototype.$isEmpty(myNextRecRest1_toDate)) {
                    this.myNextDateLine = 'next RR1: from ' + myNextRecRest1_fromDate + ' - to ' + myNextRecRest1_toDate;
                    this.myNextDateLine_ledValue = 'green';
                }

                if (Vue.prototype.$isEmpty(myNextRecRest1_fromDate) && Vue.prototype.$isEmpty(myNextRecRest1_toDate)) {
                    this.myNextDateLine = 'next RR1: no RR found, needs replanning';
                    this.myNextDateLine_ledValue = 'red';
                }


                // --------------------------------
                if (!Vue.prototype.$isEmpty(this.nextRec1Duration)) {
                    this.myNextFromToLine = '<b>' + this.nextRec1Duration + 'h</b> / min ' + this.minimumRestRec1;
                } else {
                    this.myNextFromToLine = '';
                }

            }, // eo function get_flights_ResourceDetails_NextRecRest1()



            /*******************************************************************
            * watch::get_flights_ResourceDetails_PreviousRec1Duration
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_PreviousRec1Duration(v) {

                this.previousRec1Duration = v;

            }, // eo function get_flights_ResourceDetails_PreviousRec1Duration()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_TimeBetweenRecRest1
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_TimeBetweenRecRest1(v) {

                this.timeBetweenRecRest1 = v;

            }, // eo function get_flights_ResourceDetails_TimeBetweenRecRest1()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_MaxBetweenRestRec1
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_MaxBetweenRestRec1(v) {

                this.maxBetweenRestRec1 = v;

            }, // eo function get_flights_ResourceDetails_MaxBetweenRestRec1()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_ES_LF_ND_count
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_ES_LF_ND_count(v) {

                this.ES_LF_ND_count = v;

            }, // eo function get_flights_ResourceDetails_ES_LF_ND_count()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_ResRest2
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_ResRest2(v) {

                this.resRest2 = v;

            }, // eo function get_flights_ResourceDetails_ResRest2()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_MinResRest2
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_ResourceDetails_MinResRest2(v) {

                this.minResRest2 = v;

            }, // eo function get_flights_ResourceDetails_MinResRest2()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_SavedPayload',
                'get_flights_ResourceDetails_ResourceAskedFor',
                // ------------------------------
                'get_flights_BriefDetails_Flights_ThisDay',
                'get_flights_BriefDetails_DutyCheckin_ThisDay',
                'get_flights_BriefDetails_DutyCheckout_ThisDay',
                'get_flights_BriefDetails_Sectors_ThisDay',
                'get_flights_BriefDetails_TotalFT_ThisDay',
                'get_flights_BriefDetails_TotalDT_ThisDay',
                'get_flights_BriefDetails_FlightDutyTime_FdtInfo',
                'get_flights_BriefDetails_PreviousRestPeriod_ThisDay',
                'get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay',
                'get_flights_BriefDetails_NextRestPeriod_ThisDay',
                'get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay',
                // ------------------------------
                'get_flights_ResourceDetails_PreviousRecRest1',
                'get_flights_ResourceDetails_NextRecRest1',

                'get_flights_ResourceDetails_PreviousRec1Duration',
                'get_flights_ResourceDetails_MinimumRestRec1',
                'get_flights_ResourceDetails_NextRec1Duration',





                'get_flights_ResourceDetails_TimeBetweenRecRest1',
                'get_flights_ResourceDetails_MaxBetweenRestRec1',

                'get_flights_ResourceDetails_ES_LF_ND_count',



                'get_flights_ResourceDetails_ResRest2',
                'get_flights_ResourceDetails_MinResRest2',


            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step5Content.vue >>> created');
            eventBus.$on('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step5Content.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getCrewDetailsResourceBrief_Reload'
            ]),


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePickerInBrief()
            *
            * Desc:
            * Desc:
            *
            * @param {String} value ()
            */
            onChange_DatePickerInBrief: function(values){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step5Content.vue >>> onChange_DatePickerInBrief');
                if (values.caller === 'step5') {
                    me.actn_call_getCrewDetailsResourceBrief_Reload({ date: values.date });
                }

            }, // eo function onChange_DatePickerInBrief()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * isRedOrGreen_RightSide()
            *
            * Desc: Decide which traffic light.
            * Note:
            *
            * @param {Object} values (e.g.: { semaforo: 'red', calculation: '28days' })
            */
            isRedOrGreen_RightSide: function(values) {

                let me = this,
                    semaforo = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step5Content.vue >>> isRedOrGreen_RightSide');
                if (values.calculation === 'recrest1') {
                    semaforo = this.myNextDateLine_ledValue;
                }


                if (values.calculation === 'recrest2') {
                    if (this.resRest2 > this.minResRest2) {
                        semaforo = 'green';
                    } else {
                        semaforo = 'red';
                    }
                }


                return semaforo;

            }, // eo function isRedOrGreen_RightSide()

        }, // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    #customers {
        border-collapse: collapse;
        width: 100%;
    }

    #customers td, #customers th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 13px;
    }

    #customers td {
        font-weight: 500 !important;
    }


    #customers tr:nth-child(even){background-color: #f2f2f2;}

    #customers tr:hover {background-color: #ddd;}

    #customers th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #A4C2A5;
        color: white;
        font-size: 14px;
        font-weight: 600 !important;
    }





    table.MyFlightTimeTable {
        background-color: #fff;
        width: 100%;
    }
    table.MyFlightTimeTable td {
        height: 25px;
        width: 31px;
        color: #000;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
    }
    table.MyFlightTimeTable .header_cell {
        background-color: #A4C2A5;
        color: #fff;
    }
    table.MyFlightTimeTable .cell_empty {
        background-color: #CB67A0;
    }
    table.MyFlightTimeTable .cell_with_value {
        background-color: #ccc;
    }



    .led-green {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #A4C2A5;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89ff00 0 2px 12px; */
    }

    .led-red {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #ff0000;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #e82e15 0 2px 12px; */
    }
</style>